import { useContext } from "react";
import { BucketContext } from "./context";

export const useBucketContext = () => {
  const currentContext = useContext(BucketContext);
  if (!currentContext) {
    throw new Error(
      "useBucketContext has to be used within <BucketContext.Provider>"
    );
  }
  return currentContext;
};
